import { Calendar } from '@/components/Calendar'
import { Stack, Typography } from '@mui/material'
import { useEffect } from 'react'

import { useSetCalendarConfig } from '../../../providers/CalendarConfigProvider'
import { useCalendarProps } from './useCalendarProps'
import { useTexts } from './useTexts'

type Props = {
  inEditMode: boolean
}

export function RecurrenceCalendar(props: Props) {
  const { inEditMode } = props
  const calendarProps = useCalendarProps()
  const texts = useTexts()
  const setCalendarConfig = useSetCalendarConfig()
  const { minDate, maxDate, disabledDays } = calendarProps

  useEffect(() => {
    setCalendarConfig({
      minDate: minDate as string,
      maxDate: maxDate as string,
      disabledDays: disabledDays ?? {},
    })
  }, [minDate, maxDate, disabledDays, setCalendarConfig])

  return (
    <Stack direction="column" spacing={3}>
      <Typography
        variant="body2"
        sx={theme => ({ color: theme.vars.palette.common.black, fontWeight: 500 })}
      >
        {texts.orderDateLabel}
      </Typography>
      <Calendar {...calendarProps} />
      {inEditMode && <Typography variant="caption">{texts.editModeHelperText}</Typography>}
    </Stack>
  )
}
